import React, { useState, useEffect } from "react";
import { Menu, Icon } from "antd";
import { withRouter } from "react-router-dom";
import Media from "react-media";

import { getAccessToken } from "../util/Auth";
import Header from "./Assets/Header";
import MobileHeader from "./Assets/MobileHeader.js";
import smallLogo from "../assets/smallLogo.png";

const Layout = props => {
  const { history } = props;
  const path = history.location.pathname;
  const [selected, setSelected] = useState("menu");

  const { user } = props.redux;

  useEffect(() => {
    const accessToken = getAccessToken();
    if (accessToken) {
      props.fetchUser(accessToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    selectedMenu();
  });

  const selectedMenu = () => {
    if (path === "/" || path.includes("equipment")) {
      setSelected("Equipment");
    }
    if (path.includes("about")) {
      setSelected("About");
    }
  };

  const image = () => (
    <img className="smallLogo" src={smallLogo} alt="eflogo" />
  );

  const menu = () => (
    <Media query="(max-width: 720px)">
      {matches =>
        matches ? (
          <MobileHeader history={history} name={user.user} />
        ) : (
          <>
            <div className="menu">
              <Menu
                onClick={e => setSelected(e.key)}
                selectedKeys={[selected]}
                mode="inline"
                style={{ width: "100%" }}
              >
                <Menu.Item
                  key={"title"}
                  className="menuTitle"
                  style={{ padding: "0 !important" }}
                >
                  <Icon component={image} />
                </Menu.Item>
                <Menu.Item
                  key={"Equipment"}
                  onClick={() => history.push("/equipment?clear=true")}
                >
                  Home
                </Menu.Item>
                <Menu.Item key={"About"} onClick={() => history.push("/about")}>
                  About
                </Menu.Item>
              </Menu>
            </div>
            <Header history={history} name={user.user} />
          </>
        )
      }
    </Media>
  );

  const redirect = () => {
    return <div />;
  };
  return user.validated ? menu() : redirect();
};

export default withRouter(Layout);
